import script from "./setUpAssociatePartnershipMultiple.vue?vue&type=script&setup=true&lang=js"
export * from "./setUpAssociatePartnershipMultiple.vue?vue&type=script&setup=true&lang=js"

import "./setUpAssociatePartnershipMultiple.vue?vue&type=style&index=0&id=63e379ab&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e379ab"]])

export default __exports__